
const getAccountList = async (mvcmydashboard) => {
	var  list = [];

	let sessionuuid = await mvcmydashboard.getCurrentSession();
	let bRefresh = true;
	let bIncludeReadOnly = true;
	let accounts = await mvcmydashboard.getSessionAccounts(sessionuuid, bRefresh, bIncludeReadOnly).catch(err => {});

	for (var i = 0; i < (accounts ? accounts.length : 0); i++) {
		let account = accounts[i];
		let record = {id: account.uuid, uuid: account.uuid, 
			address: account.address, description: account.description, 
			type: account.type, origin: account.origin, public_key: account.public_key, rsa_public_key: account.rsa_public_key };

		list.push(record);
	}

	return list;
};


export default {
	getFullList: async (mvcmydashboard) => {
		let list = [];

		if (!mvcmydashboard) return list;

		list = await getAccountList(mvcmydashboard);

		return list;
	},

/*	getList: async (mvcmydashboard, params) => {
		const { page, perPage } = params.pagination;
		const { field, order } = params.sort;

		let list = [];

		if (!mvcmydashboard) return {data: list, total: list.length};

		list = await getAccountList(mvcmydashboard);

		return {data: list, total: list.length};
	},

 	getOne: async (mvcmydashboard, params) => {
		const { id } = params.id;

		let item = {id};

		if (!mvcmydashboard) return {data: item};

		let list = await getAccountList(mvcmydashboard);

		for (var i = 0; i < (list ? list.length: 0); i++) {
			if (list[i] && list[i].id === id) {
				item = list[i];
				break;
			}
		}

		return {data: item}
	}, */

	getMany: async (mvcmydashboard, params) => {
		throw new Error('getMany not implemented');
	},

	getManyReference: async (mvcmydashboard, params) => {
		throw new Error('getManyReference not implemented');
	},

	update: async (mvcmydashboard, params) => {
		let accountuuid = params.id;
		let data = params.data;
		let description = data.description;

		if (!mvcmydashboard) return {data};

		let info = {description};

		let sessionuuid = await mvcmydashboard.getCurrentSession();

		let res = await mvcmydashboard.setAccountInfo(sessionuuid, accountuuid, info);

		return {data};
	},

	updateMany: async (mvcmydashboard, params) => {
		throw new Error('updateMany not implemented');
	},

	create: async (mvcmydashboard, params) => {
		let data = params.data;
		let description = data.description;
		let address = data.address;
		let private_key = data.private_key;

		if (!mvcmydashboard) return {data};

		let sessionuuid = await mvcmydashboard.getCurrentSession();

 		let account = await mvcmydashboard.createAccount(sessionuuid, address, private_key);
		let info = {description};
		let res = await mvcmydashboard.setAccountInfo(sessionuuid, account.uuid, info);

		return {data};
	},

	delete: async (mvcmydashboard, params) => {
		throw new Error('delete not implemented');
	},

	deleteMany: async (mvcmydashboard, params) => {
		throw new Error('deleteMany not implemented');
	},
};